import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const initialState = () => {
    return {
        name: '',
        email: '',
        authenticated: false,
        permissions: {},
        autino: true
    };
};

const getters = {
    state: state => state,
    email: state => state.email,
    name: state => state.name,
    authenticated: state => state.authenticated,
    permissions: state => state.permissions,
    autino: state => state.autino
}

const actions = {
    resetState: ({ commit }) => commit('resetState'),
    updateEmail: ({ commit }, payload) => commit('setEmail', payload),
    updateName: ({ commit }, payload) => commit('setName', payload),
    updateAuthenticated: ({ commit }, payload) => commit('setAuthenticated', payload),
    updatePermissions: ({ commit }, payload) => commit('setPermissions', payload),
    updateAutino: ({ commit }, payload) => commit('setAutino', payload),
}

const mutations = {
    resetState(state) {
        Object.assign(state, initialState());
    },
    setEmail(state, payload) {
        state.email = payload;
    },
    setName(state, payload) {
        state.name = payload;
    },
    setAuthenticated(state, payload) {
        state.authenticated = payload;
    },
    setPermissions(state, payload) {
        state.permissions = payload;
    },
    setAutino(state, payload) {
        state.autino = payload;
    }
}

const modules = {}

export default {
    namespaced: true,
    state: initialState(),
    getters,
    mutations,
    actions,
    modules
};



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js